import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { lazyInject } from 'src/ioc';
import { RouterStore } from 'src/core/stores/router.store';
import { UIStatusStore } from 'src/core/stores/ui-status.store';

// https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md

class ScrollToTopImpl extends Component<RouteComponentProps<any>> {
    @lazyInject(RouterStore) router!: RouterStore;
    @lazyInject(UIStatusStore) uiStatus!: UIStatusStore;

    componentDidUpdate(prevProps: RouteComponentProps<any>) {
        if (this.props.location !== prevProps.location) {
            if (this.router.skipScrollOnNextRouteChange) {
                this.router.skipScrollOnNextRouteChange = false;
                return;
            }

            window.scrollTo(0, 0);

        }
    }

    render() {
        return null;
    }
}

export const ScrollToTop = withRouter(ScrollToTopImpl);
